module.exports = __webpack_public_path__ + "static/img/iberica-logo-white.613622f.svg";